/**
 * Variant Extractor
 * 全バリアントから条件を抽出（PrintHubロジックを参考）
 */

(function() {
  'use strict';

  /**
   * 全バリアントから条件を抽出
   * @param {Array} variants - Shopifyバリアント配列
   * @param {Array} shopifyOptions - Shopifyオプション定義
   * @returns {Object} - 抽出された条件とマッピング
   */
  function extractConditionsFromVariants(variants, shopifyOptions) {
    if (!Array.isArray(variants) || !Array.isArray(shopifyOptions)) {
      console.warn('[Variant Extractor] Invalid input:', { variants, shopifyOptions });
      return {
        conditions: {},
        byPaper: {},
        byPrintColor: {},
        byOption: {}
      };
    }

    const conditions = {};              // すべてのバリアントの条件
    const byPaper = {};                 // 全バリアント: 用紙 → 印刷色数の配列
    const byPrintColor = {};            // 全バリアント: 印刷色数 → 用紙の配列
    const byOption = {};                // 汎用マッピング
    
    variants.forEach((variant) => {
      // variant.options または variant.option1, option2 から値を取得
      const variantOptions = window.buildVariantOptions(variant, shopifyOptions);
      
      if (variantOptions && typeof variantOptions === 'object' && Object.keys(variantOptions).length > 0) {
        const optionEntries = Object.entries(variantOptions);
        
        // すべての条件を収集
        optionEntries.forEach(([optionName, optionValue]) => {
          if (optionValue && optionValue !== 'null' && optionValue !== '') {
            if (!conditions[optionName]) {
              conditions[optionName] = new Set();
            }
            conditions[optionName].add(optionValue);
          }
        });
        
        // 連動マッピングの構築（全バリアント）
        const paper = variantOptions['用紙'];
        const printColor = variantOptions['印刷色数'];
        
        if (paper && printColor && paper !== 'null' && printColor !== 'null') {
          // 全バリアント用マッピング
          if (!byPaper[paper]) {
            byPaper[paper] = new Set();
          }
          byPaper[paper].add(printColor);
          
          if (!byPrintColor[printColor]) {
            byPrintColor[printColor] = new Set();
          }
          byPrintColor[printColor].add(paper);
        }
        
        // 汎用マッピング（全バリアント）
        optionEntries.forEach(([optionName, optionValue]) => {
          if (optionValue && optionValue !== 'null' && optionValue !== '') {
            if (!byOption[optionName]) {
              byOption[optionName] = {};
            }
            if (!byOption[optionName][optionValue]) {
              byOption[optionName][optionValue] = new Set();
            }
            
            optionEntries.forEach(([otherName, otherValue]) => {
              if (otherName !== optionName && otherValue && otherValue !== 'null' && otherValue !== '') {
                byOption[optionName][optionValue].add(`${otherName}:${otherValue}`);
              }
            });
          }
        });
      }
    });
    
    // SetをArrayに変換してソート
    const formatConditions = (conditionsObj) => {
      const formatted = {};
      Object.keys(conditionsObj).forEach((key) => {
        const values = Array.from(conditionsObj[key]);
        // 用紙の場合は重量でソート
        if (key === '用紙' || key.includes('用紙')) {
          values.sort((a, b) => {
            const weightA = a.match(/(\d+)kg/);
            const weightB = b.match(/(\d+)kg/);
            if (weightA && weightB) {
              const numA = parseInt(weightA[1]);
              const numB = parseInt(weightB[1]);
              if (numA !== numB) return numA - numB;
            }
            // コート/マットでソート
            if (a.includes('コート') && b.includes('マット')) return -1;
            if (a.includes('マット') && b.includes('コート')) return 1;
            return a.localeCompare(b, 'ja');
          });
        } else {
          // それ以外は文字列でソート
          values.sort((a, b) => a.localeCompare(b, 'ja'));
        }
        formatted[key] = values;
      });
      return formatted;
    };
    
    return {
      conditions: formatConditions(conditions),
      byPaper: Object.fromEntries(
        Object.entries(byPaper).map(([k, v]) => [k, Array.from(v)])
      ),
      byPrintColor: Object.fromEntries(
        Object.entries(byPrintColor).map(([k, v]) => [k, Array.from(v)])
      ),
      byOption: Object.fromEntries(
        Object.entries(byOption).map(([k, v]) => 
          [k, Object.fromEntries(Object.entries(v).map(([k2, v2]) => [k2, Array.from(v2)]))]
        )
      )
    };
  }

  // グローバルに公開
  window.extractConditionsFromVariants = extractConditionsFromVariants;

})();

